import React from 'react'

export default function TopicCard({ title, body, children, dark = false }) {
  return (
    <div className={`rounded-2xl pt-5 md:pt-6 pb-2.5 md:pb-3 px-5 md:px-6 flex flex-col gap-2 border transition-colors ${
      dark
        ? 'bg-divider-on-dark border-divider-on-dark hover:border-secondary-on-dark'
        : 'bg-color-card-overlay border-color-bg-light hover:border-color-secondary'
    }`}>
      <h3 className={`typography-h4 ${
        dark ? 'text-primary-on-dark' : 'text-color-primary'
      }`}>{title}</h3>
      {(body || children) && (
        body ? (
          <p className={`typography-body ${
            dark ? 'text-on-dark' : 'text-color-text'
          }`}>{body}</p>
        ) : (
          children
        )
      )}
    </div>
  )
}
